import React from 'react'
import { X } from 'lucide-react'

// Misma firma que el SVG anterior: stroke es el color y width el grosor del trazo en px
// (absoluteStrokeWidth), así que width="1" sigue dando una X fina.
const Icon = ({ fill = 'none', stroke = 'white', width = '2' }) => (
  <X size={16} color={stroke || 'white'} fill={fill || 'none'} strokeWidth={Number(width) || 2} absoluteStrokeWidth />
)

export default Icon
